var komentar_odesilani = false;
var komentar_hodnoceni_odesilani = false;
var koment_klic = "";
var koment_vysledek = "";
var koment_odpoved = 0;

function komentar_pridat()
{
	if (komentar_odesilani) return false;
	var chyby = new Array;
	var elementChyby = $("#komentareChyby");
	var jmeno = $("#komentarJmeno").val();
	var predmet = $("#komentarPredmet").val();
	var komentar = $("#komentarKomentar").val();
	var cislo = $("#komentarCislo").val();
	if (!jmeno) chyby[0] = "Jm\u00e9no nen\u00ed vypln\u011bno.";
	if (!predmet) chyby[1] = "P\u0159edm\u011bt nen\u00ed vypln\u011bn.";
	if (!komentar) chyby[4] = "Koment\u00e1\u0159 nen\u00ed vypln\u011bn.";
	if (cislo.length <
		1) chyby[5] = "P\u0159\u00edklad nebyl vypo\u010d\u00edt\u00e1n.";
	if (chyby.length > 0)
	{
		elementChyby.html("");
		for (chyba in chyby) elementChyby.append('<div class="alert alert-warning">' + chyby[chyba] + "</div>\n")
	}
	else
	{
		elementChyby.html("");
		$.ajax({
			url: "/ajax/komentar.php",
			dataType: "json",
			type: "POST",
			data: {
				jmeno: jmeno,
				predmet: predmet,
				komentar: komentar,
				stranka: window.stranka || 0,
				vysledek: koment_vysledek,
				klic: koment_klic,
				cislo: cislo,
				odpoved: koment_odpoved
			},
			timeout: 3E4,
			beforeSend: function () {
				elementChyby.html('<div class="alert alert-info">Prob\u00edh\u00e1 odes\u00edl\u00e1n\u00ed koment\u00e1\u0159e...</div>\n');
				komentar_odesilani = true
			},
			success: function (data) {
				komentar_odesilani = false;
				if (!data["status"] || data["status"] == "error" || data["status"] != "ok")
				{
					if (data["error"]) elementChyby.html(data["error"]);
					else elementChyby.html('<div class="alert alert-info">P\u0159i odes\u00edl\u00e1n\u00ed nastala bl\u00ed\u017ee neur\u010den\u00e1 chyba.</div>\n');
					if (data["captcha"])
					{
						koment_vysledek = data["captcha"]["vysledek"];
						koment_klic = data["captcha"]["klic"];
						$("#komentarCaptcha").attr("src", "/images/captcha.php?kod=" + encodeURIComponent(data["captcha"]["priklad"]) +
							"&klic=" + encodeURIComponent(koment_klic));
						$("#komentarCislo").val("")
					}
				}
				else
				{
					komentar_odesilani = true;
					elementChyby.html('<div class="alert alert-success">Koment\u00e1\u0159 byl \u00fasp\u011b\u0161n\u011b p\u0159id\u00e1n.</div>\n');
					$("#komentarJmeno").val("");
					$("#komentarPredmet").val("");
					$("#komentarKomentar").val("");
					$("#komentarCislo").val("");
					komentar_smazatOdpoved();
					setTimeout(function () {
						url = location.pathname.replace(/\/+\d+\/*$/, "");
						url = url.replace(/\/*$/, "");
						url = url + "/";
						location.reload();
					}, 2E3)
				}
			},
			error: function (xhr, status) {
				komentar_odesilani = false;
				switch (status)
				{
					case "timeout":
						elementChyby.html('<div class="alert alert-warning">Vypr\u0161el \u010dasov\u00fd limit odes\u00edl\u00e1n\u00ed.</div>\n');
						break;
					case "abort":
						elementChyby.html('<div class="alert alert-warning">Odes\u00edl\u00e1n\u00ed bylo p\u0159eru\u0161eno.</div>\n');
						break;
					default:
						elementChyby.html('<div class="alert alert-warning">P\u0159i odes\u00edl\u00e1n\u00ed nastala bl\u00ed\u017ee neur\u010den\u00e1 chyba.</div>\n');
						break
				}
			}
		})
	}
}

function komentar_odpoved(id, predmet)
{
	koment_odpoved = id;
	$("#komentarTr").show();
	$("#komentarPredmet").val("Re: " + (predmet.length < 29 ? predmet : predmet.substring(0, 28)));
	$("#komentarOdpoved").val(predmet);
	$([document.documentElement, document.body]).animate
	({ scrollTop: $("#komentare").offset().top }, 300);
}

function komentar_smazatOdpoved()
{
	koment_odpoved = 0;
	$("#komentarTr").hide();
	$("#komentarOdpoved").val("")
}

function komentar_hodnoceni(id, hlas)
{
	var proProti = $("#proProti" + id);
	var proProtiHTML = proProti.html();
	if (proProti && !komentar_hodnoceni_odesilani)
	{
		if (hlas != 0 && hlas != 1)
		{
			proProti.html("<strong>Lze hlasovat pouze pro nebo proti.</strong>");
			setTimeout(function () {proProti.html(proProtiHTML)}, 3E3);
			return
		}
		$.ajax({
			url: "/ajax/komentar-hodnoceni.php",
			dataType: "json",
			type: "POST",
			data: { id: id, hlas: hlas },
			timeout: 3E4,
			beforeSend: function () {
				proProti.html("<strong>Odes\u00edl\u00e1n\u00ed...</strong>");
				komentar_hodnoceni_odesilani = true
			},
			success: function (data) {
				komentar_hodnoceni_odesilani = false;
				if (!data["status"] || data["status"] == "error" || data["status"] != "ok")
				{
					if (data["error"]) proProti.html(data["error"]);
					else proProti.html("<strong>Chyba.</strong>");
					setTimeout(function () {proProti.html(proProtiHTML)}, 3E3)
				}
				else if (!data["pro"] || !data["proti"]) location.reload();
				else
				{
					if (hlas) proProti.html("<a class=\"comment__rating comment__rating--positive comment__rating--rated comment__rating--my\">" + data["pro"] + "</a> x <a class=\"comment__rating comment__rating--negative comment__rating--rated comment__rating--opposite\">" + data["proti"] + "</a>");
					else proProti.html("<a class=\"comment__rating comment__rating--positive comment__rating--rated comment__rating--opposite\">" + data["pro"] + "</a> x <a class=\"comment__rating comment__rating--negative comment__rating--rated comment__rating--my\">" + data["proti"] + "</a>");
				}
			},
			error: function (xhr, status) {
				komentar_hodnoceni_odesilani = false;
				switch (status)
				{
					case "timeout":
						proProti.html("<strong>\u010cas odes\u00edl\u00e1n\u00ed vypr\u0161el.</strong>");
						break;
					case "abort":
						proProti.html("<strong>Odes\u00edl\u00e1n\u00ed bylo zru\u0161eno.</strong>");
						break;
					default:
						proProti.html("<strong>Chyba.</strong>");
						break
				}
				setTimeout(function () {proProti.html(proProtiHTML)}, 3E3)
			}
		})
	}
}

function komentar_vlozit(pred, za)
{
	if (!pred && !za) return;
	var area = $("#komentarKomentar")[0];
	area.focus();
	if (area.selectionStart || area.selectionStart == 0)
	{
		var startPos = area.selectionStart;
		var endPos = area.selectionEnd;
		var text = area.value.substring(0, startPos) + pred + area.value.substring(startPos, endPos) + za;
		var delka = text.length;
		text += area.value.substring(endPos, area.value.length);
		area.value = text;
		area.selectionStart = delka;
		area.selectionEnd = delka
	}
	else area.value += pred + za
};
